import { render, staticRenderFns } from "./EditorImage.vue?vue&type=template&id=91d2c1e6&scoped=true"
import script from "./EditorImage.vue?vue&type=script&lang=js"
export * from "./EditorImage.vue?vue&type=script&lang=js"
import style0 from "./EditorImage.vue?vue&type=style&index=0&id=91d2c1e6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91d2c1e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitHub\\ita.GroupTravel.Website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('91d2c1e6')) {
      api.createRecord('91d2c1e6', component.options)
    } else {
      api.reload('91d2c1e6', component.options)
    }
    module.hot.accept("./EditorImage.vue?vue&type=template&id=91d2c1e6&scoped=true", function () {
      api.rerender('91d2c1e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TinymceForApp/components/EditorImage.vue"
export default component.exports